module.exports = __webpack_public_path__ + "img/freight-non-eturnable.1bde5f0.svg";